
import { 
    FaHashtag,  
    FaUser,  
    AppEnum,
    Header, 
    FaTasks,
    TaskEnums
} from "@/Shared";

import { TaskViewModel } from ".";

export type SelectOption = {
    value: any,
    label: any
}

export class TaskHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    getCategory(categoryTypes: AppEnum[]) {
        return {
            key: 'category',
            icon: <FaTasks />,
            label: 'Catégorie de la tâche',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Catégorie",
                options: categoryTypes,
                case: 'sensitive'
            }
        }
    }

    get creationDate() {
        return {
            key: 'creationDate',
            icon: <FaUser />,
            label: 'Date Création',
            type: 'date',
            isSortable: true
        }
    }


    get creator() {
        return {
            key: 'creatorName',
            icon: <FaUser />,
            label: 'Auteur',
            type: 'string',
            isSortable: true
        }
    }

    get label() {
        return {
            key: 'label',
            icon: <FaTasks />,
            label: 'Label',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Label",
                case: 'insensitive'
            }
        }
    }

    static build( viewEnums : TaskEnums ): Record<keyof TaskViewModel, Header<TaskViewModel>> {

        const header = new TaskHeader();

        return {
           id : header.id,
           label : header.label,
           category : header.getCategory(viewEnums.TaskCategoryEnum),
           creationDate : header.creationDate,
           creatorName : header.creator,
        } as Record<keyof TaskViewModel, Header<TaskViewModel>>
    }
}